"use strict";

(function() {
	const menus = Array.from(document.querySelectorAll('.context-menu'));
	if( menus.length === 0 ) {
		return;
	}

	const OPEN_CLASSNAME = 'is-open';

	menus.forEach(menu => {
		const handler = menu.querySelector('.context-menu-handler');
		const body = menu.querySelector('.context-menu-body');
		if(! handler || ! body ) {
			return;
		}

		const handleClick = (event) => {
			event.preventDefault();
			if( menu.classList.contains(OPEN_CLASSNAME) ) {
				_close();
			} else {
				_open();
			}
		};

		const _handleOutsideClick = (event) => {
			const _maybeMenu = event.target.closest('.context-menu');
			if(! (_maybeMenu && _maybeMenu === menu) ) {
				_close();
			}
		}

		const _open = () => {
			menu.classList.add(OPEN_CLASSNAME);
			body.setAttribute('aria-expanded', 'true');
			document.body.addEventListener('click', _handleOutsideClick);
		};

		const _close = () => {
			menu.classList.remove(OPEN_CLASSNAME);
			body.setAttribute('aria-expanded', 'false');
			document.body.removeEventListener('click', _handleOutsideClick);
		};

		handler.addEventListener('click', handleClick);
	});
})();